import { render, staticRenderFns } from "./InvalidComponent.vue?vue&type=template&id=2ea295e4"
import script from "./InvalidComponent.vue?vue&type=script&lang=js"
export * from "./InvalidComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports